import { Button } from '@mui/material';
import { EnhancedTabs } from 'components/enhanced/tabs/EnhancedTabs';
import { TenantPage } from 'layouts';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { tenantSettingsService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import { TenantSettingsForm } from '../TenantSettingsForm';
import { ITenantSettings } from '../types';

export const TenantSettings = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.tenant-settings.edit';
  const navigate = useNavigate();

  const [tenantSettings, setTenantSettings] = useState<ITenantSettings>();
  const downloadableFields = ['logo', 'logo_extra'];

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();

  const updateSettings = async (values) => {
    dispatch(loadingActions.startLoading());
    tenantSettingsService.update(1, values).then(() => {
      enqueueSnackbar('Impostazioni salvate con successo', { variant: 'success' });
    });
    dispatch(loadingActions.stopLoading());
  };

  useEffect(() => {
    tenantSettingsService.get(1).then(setTenantSettings);
  }, []);

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={
        <Button color="primary" onClick={() => navigate('sap')}>
          {t('entities.tenant-settings.sap')}
        </Button>
      }>
      {tenantSettings && (
        <EnhancedTabs
          tabs={[
            {
              label: t(`global.base-info`),
              component: (
                <TenantSettingsForm tenantSettings={tenantSettings} onSubmit={updateSettings} />
              )
            }
          ]}
          variant="scrollable"
          attachmentsConfig={{
            fields: downloadableFields,
            entity: tenantSettings,
            service: tenantSettingsService,
            translationPrefix: `entities.tenant-settings`
          }}
        />
      )}
    </TenantPage>
  );
};

export default TenantSettings;
